import React from "react";
import SFDialog from "../../../dialog";

const ActionConfirmation = (props) => {
  const handleConfirm = () => {
    // For sync actions, we execute the onConfirm function and then close the confirmation
    props.onConfirm();
    props.onClose();
  };

  const handleConfirmAsync = async () => {
    // For async actions, we await the onConfirm and if it is successful, we close the confirmation
    await props.onConfirm();
    props.onClose();
  };

  return (
    <SFDialog
      variant={props.variant ?? "info"}
      title={props.title}
      message={props.message}
      open={props.open}
      closeButton
      onClose={props.onClose}
      primaryButton
      primaryButtonProps={{
        label: props.primaryLabel,
        disabled: props.primaryDisabled,
        onClick: !props.async ? handleConfirm : handleConfirmAsync,
        async: props.async,
        onError: props.onError,
      }}
      secondaryButton
      secondaryButtonProps={{
        label: props.cancelLabel,
        disabled: props.cancelDisabled,
        onClick: props.onClose,
      }}
    />
  );
};

export default ActionConfirmation;
